(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementRotator {
    constructor(list) {
      this.list = list;
      this.items = [...list.querySelectorAll('.announcement__item')];
      this.index = 0;
      const seconds = parseFloat(getComputedStyle(list).getPropertyValue('--announcement-interval')) || 5;
      this.timer = window.setInterval(() => this.advance(), seconds * 1000);
      list.closest('.announcement').addEventListener('mouseenter', () => this.pause());
      list.closest('.announcement').addEventListener('mouseleave', () => this.resume(seconds));
    }

    advance() {
      this.items[this.index].hidden = true;
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].hidden = false;
    }

    pause() {
      window.clearInterval(this.timer);
    }

    resume(seconds) {
      this.timer = window.setInterval(() => this.advance(), seconds * 1000);
    }
  }

  function initAnnouncements() {
    document.querySelectorAll('.announcement__list--rotating').forEach((list) => {
      if (list.dataset.rotating) return;
      list.dataset.rotating = 'true';
      new AnnouncementRotator(list);
    });
  }

  document.addEventListener('DOMContentLoaded', initAnnouncements);
  document.addEventListener('shopify:section:load', initAnnouncements);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * Keeps the drawer, the header bubble and the /cart page in step with the
   * Cart AJAX API. Every mutation re-fetches the rendered section rather than
   * patching the DOM by hand, so Liquid stays the single source of truth.
   */
  class CartController {
    constructor() {
      this.shippingNoticeDismissed = false;

      document.addEventListener('click', (event) => {
        const dismissShipping = event.target.closest('[data-dismiss-shipping]');
        if (dismissShipping) {
          const notice = dismissShipping.closest('[data-shipping-notice]');
          if (notice) notice.hidden = true;
          this.shippingNoticeDismissed = true;
          return;
        }

        const duoRemove = event.target.closest('[data-duo-remove]');
        if (duoRemove) {
          const keys = (duoRemove.dataset.lineKeys || '').split(',').filter(Boolean);
          this.removeLines(keys);
          return;
        }

        const button = event.target.closest('[data-qty-change]');
        if (!button) return;
        const line = button.closest('[data-line-key]');
        if (!line) return;
        this.change(line.dataset.lineKey, Number(button.dataset.qtyChange));
      });

      document.addEventListener('change', (event) => {
        const select = event.target.closest('[data-duo-option-change]');
        if (!select) return;
        this.changeDuoOption(select);
      });

      document.addEventListener('smossie:cart:changed', (event) => {
        this.refresh(event.detail?.open);
      });

      this.restoreShippingNotice();
    }

    restoreShippingNotice() {
      if (this.shippingNoticeDismissed) {
        document.querySelector('[data-shipping-notice]')?.setAttribute('hidden', '');
      }
    }

    async change(key, quantity) {
      const routes = window.Smossie?.routes || {};
      const response = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) return;
      document.dispatchEvent(new CustomEvent('smossie:cart:changed', { detail: { open: false } }));
    }

    async removeLines(keys) {
      if (!keys.length) return;
      const routes = window.Smossie?.routes || {};
      const updates = Object.fromEntries(keys.map((key) => [key, 0]));
      const response = await fetch(`${routes.cartUpdate || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) return;
      const cart = await response.json();
      const hasDuo = cart.items.some((item) => item.properties?._duo_id);
      if (!hasDuo) {
        const remainingCodes = (cart.discount_codes || [])
          .map((discount) => discount.code)
          .filter((code) => code.toUpperCase() !== 'DUOPACK');
        await fetch(`${routes.cartUpdate || '/cart/update'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });
      }
      document.dispatchEvent(new CustomEvent('smossie:cart:changed', { detail: { open: false } }));
    }

    changeDuoOption(select) {
      const editor = select.closest('[data-duo-suit-edit]');
      const variantsNode = select.closest('.cart-line__duo-edit')?.querySelector('[data-cart-suit-variants]');
      if (!editor || !variantsNode) return;
      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent) || [];
      } catch {
        return;
      }
      const colour = editor.querySelector('[data-duo-option-index="0"]')?.value;
      const size = editor.querySelector('[data-duo-option-index="1"]')?.value;
      const variant = variants.find(
        (candidate) =>
          candidate.options?.[0] === colour &&
          candidate.options?.[1] === size &&
          candidate.available,
      );
      if (!variant) {
        select.value = select.dataset.currentOption;
        return;
      }
      this.changeDuoVariant(select, variant.id);
    }

    async changeDuoVariant(select, nextVariantId) {
      nextVariantId = Number(nextVariantId);
      if (
        !nextVariantId ||
        nextVariantId === Number(select.dataset.currentVariant) ||
        select.disabled
      ) return;
      select.disabled = true;
      const routes = window.Smossie?.routes || {};

      try {
        const addResponse = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: nextVariantId,
              quantity: 1,
              properties: {
                _duo_id: select.dataset.duoId,
                _duo_position: select.dataset.duoPosition,
              },
            }],
          }),
        });
        if (!addResponse.ok) return;
        const added = await addResponse.json();

        const removeResponse = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: select.dataset.lineKey, quantity: 0 }),
        });
        if (!removeResponse.ok) {
          const addedKey = added.items?.[0]?.key;
          if (addedKey) {
            await fetch(`${routes.cartChange || '/cart/change'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: addedKey, quantity: 0 }),
            });
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('smossie:cart:changed', { detail: { open: false } }));
      } finally {
        select.disabled = false;
      }
    }

    async refresh(shouldOpen) {
      const drawer = document.getElementById('cart-drawer');
      const wasOpen = drawer?.hasAttribute('open');

      const [drawerHtml, cartJson] = await Promise.all([
        window.Smossie.fetchSection('cart-drawer'),
        fetch(`${window.Smossie.routes.cart || '/cart'}.js`).then((response) => response.json()),
      ]);

      if (drawer) {
        const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const next = parsed.getElementById('cart-drawer');
        if (next) {
          drawer.replaceWith(next);
          this.restoreShippingNotice();
          if (wasOpen || shouldOpen) next.open();
          document.dispatchEvent(
            new CustomEvent('smossie:section:replaced', { detail: { root: next } })
          );
        }
      }

      const bubble = document.querySelector('[data-cart-count]');
      if (bubble) {
        bubble.textContent = cartJson.item_count;
        bubble.hidden = cartJson.item_count === 0;
      }

      // The /cart page mirrors the same lines, so keep it fresh too.
      const cartPage = document.querySelector('[data-cart-page]');
      if (cartPage) {
        const html = await window.Smossie.fetchSection('main-cart', window.Smossie.routes.cart);
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.querySelector('[data-cart-page]');
        if (next) cartPage.replaceWith(next);
      }
    }
  }

  if (!window.SmossieCartController) {
    window.SmossieCartController = new CartController();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-wear"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wear-guide').forEach((guide) => {
    const steps = guide.querySelector('.wear-guide__steps');
    const progress = guide.querySelector('.wear-guide__progress');
    const fill = progress?.querySelector('span');
    if (!steps || !progress || !fill || steps.dataset.progressReady) return;

    steps.dataset.progressReady = 'true';
    const updateProgress = () => {
      const maxScroll = steps.scrollWidth - steps.clientWidth;
      const ratio = maxScroll > 0 ? steps.scrollLeft / maxScroll : 0;
      fill.style.width = `${25 + ratio * 75}%`;
    };

    steps.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /**
   * Product form. Keeps three things in sync: the radio inputs, the hidden
   * variant id Shopify actually reads, and the gallery.
   */
  class SmossieProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.colourLabel = this.querySelector('[data-colour-label]');
      this.submit = this.querySelector('[data-add-to-cart]');
      this.errorEl = this.querySelector('[data-cart-error]');
      this.gallery = this.querySelector('.pdp__gallery');
      this.mobileLayout = window.matchMedia('(width < 60rem)');
      this.desktopLayout = this.gallery?.dataset.desktopLayout;
      this.onLayoutChange = () => this.renderGallery({ scroll: false });
      this.mobileLayout.addEventListener('change', this.onLayoutChange);
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.thumbRail = this.querySelector('[data-thumbs]');
      this.variants = this.readVariants();
      this.duoComponentVariants = this.readJson('[data-duo-component-variants]');
      this.applyStock(this.variants, '[data-variant-stock]');
      this.applyStock(this.duoComponentVariants, '[data-duo-component-stock]');
      this.duoMode = this.dataset.duoMode === 'true';

      /** Colour the gallery is filtered to. Null means "show everything". */
      this.galleryColour = null;
      this.active = -1;
      this.ringColour = '';
      this.ringColours = [
        'var(--color-pink)',
        'var(--color-sky-blue)',
        'var(--color-coral-red-500)',
        'var(--color-butter-yellow)',
        'var(--color-mint-green)',
        'var(--color-lilac)',
      ];
      this.selectInitialColour();
      this.updateStockOptions();

      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-option-input], [data-duo-choice]')) return;
        this.onOptionChange(event.target);
      });

      // A radio that is already checked fires no change event, so the
      // tap-to-clear gesture has to be read from the click itself.
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-option-input][name="option-colour"]');
        if (swatch) this.onColourClick(swatch);

        const arrow = event.target.closest('[data-nav]');
        if (arrow) this.step(Number(arrow.dataset.nav));

        const thumb = event.target.closest('[data-thumb]');
        if (thumb) this.activate(Number(thumb.dataset.thumb));
      });

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));

      this.renderGallery({ scroll: false });
      if (this.duoMode) {
        this.querySelectorAll('input[name*=" colour"]:checked').forEach((input) => {
          this.updateSelectionPreview(input);
        });
        this.updateDuoState();
      } else {
        const colour = this.querySelector('input[name="option-colour"]:checked');
        if (colour && this.colourLabel) {
          this.colourLabel.textContent =
            colour.closest('label')?.querySelector('.visually-hidden')?.textContent || '';
        }
        if (colour) this.updateSelectionPreview(colour);
        this.updateVariant();
      }
    }

    disconnectedCallback() {
      this.mobileLayout?.removeEventListener('change', this.onLayoutChange);
    }

    readVariants() {
      return this.readJson('[data-variant-data]');
    }

    readJson(selector) {
      const node = this.querySelector(selector);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent) || [];
      } catch {
        return [];
      }
    }

    applyStock(variants, selector) {
      const quantities = new Map(this.readJson(selector).map((item) => [String(item.id), item.quantity]));
      variants.forEach((variant) => {
        variant.inventory_quantity = quantities.get(String(variant.id));
      });
    }

    selectInitialColour() {
      const params = new URL(window.location.href).searchParams;
      const requestedVariant = this.variants.find(
        (variant) => variant.id === Number(params.get('variant')),
      );
      const requested = params.get('colour') || requestedVariant?.options?.[0] || '';
      const normalize = (value) =>
        String(value || '').toLowerCase().replace(/[\s_-]+/g, '');

      if (this.duoMode) {
        const groups = new Map();
        this.querySelectorAll('input[data-duo-choice][name*=" colour"]').forEach((input) => {
          if (!groups.has(input.name)) groups.set(input.name, []);
          groups.get(input.name).push(input);
        });
        groups.forEach((inputs) => {
          const match = requested
            ? inputs.find((input) => normalize(input.value) === normalize(requested))
            : null;
          const selected = match || inputs[0];
          if (selected) selected.checked = true;
        });
        return;
      }

      const inputs = [...this.querySelectorAll('input[name="option-colour"]')];
      if (!inputs.length || inputs.some((input) => input.checked)) return;
      const match = requested
        ? inputs.find((input) => normalize(input.value) === normalize(requested))
        : null;
      const selected = match || inputs[0];
      if (selected) selected.checked = true;

      // A colour-strip deep link should open on the matching gallery image,
      // while a normal product visit still starts with the complete gallery.
      if (selected === match && (params.has('colour') || params.has('variant'))) {
        this.galleryColour = this.canonicalOptionValue(selected);
      }
    }

    get selectedColour() {
      return this.querySelector('input[name="option-colour"]:checked')?.value || '';
    }

    get selectedSize() {
      return this.querySelector('input[name="option-size"]:checked')?.value || '';
    }

    canonicalOptionValue(input) {
      if (!input) return '';
      const optionIndex = input.name?.includes('colour') ? 0 : 1;
      const position = Number(input.dataset.optionPosition);
      if (!Number.isInteger(position)) return input.value;

      const values = [];
      const variants = this.duoMode ? this.duoComponentVariants : this.variants;
      variants.forEach((variant) => {
        const value = variant.options?.[optionIndex];
        if (value && !values.includes(value)) values.push(value);
      });
      return values[position] || input.value;
    }

    inStock(variant) {
      return Boolean(variant?.available) &&
        (variant.inventory_management == null || variant.inventory_quantity > 0);
    }

    updateStockOptions() {
      if (this.duoMode) {
        this.querySelectorAll('input[data-duo-choice][name*=" size"]').forEach((input) => {
          const suitNumber = input.name.match(/Suit (\d+)/)?.[1];
          const colour = this.canonicalOptionValue(this.querySelector(
            `input[name="properties[Suit ${suitNumber} colour]"]:checked`,
          ));
          const size = this.canonicalOptionValue(input);
          input.disabled = !this.duoComponentVariants.some(
            (variant) => variant.options?.[0] === colour &&
              variant.options?.[1] === size && this.inStock(variant),
          );
          if (input.disabled) input.checked = false;
        });
        return;
      }
      this.querySelectorAll('input[name="option-size"]').forEach((input) => {
        const size = this.canonicalOptionValue(input);
        const colour = this.canonicalOptionValue(this.querySelector('input[name="option-colour"]:checked'));
        input.disabled = !this.variants.some(
          (variant) => variant.options?.[1] === size &&
            (!colour || variant.options?.[0] === colour) && this.inStock(variant),
        );
        if (input.disabled) input.checked = false;
      });
    }

    get selectedOptions() {
      return [
        this.canonicalOptionValue(this.querySelector('input[name="option-colour"]:checked')),
        this.canonicalOptionValue(this.querySelector('input[name="option-size"]:checked')),
      ].filter(Boolean);
    }

    onOptionChange(input) {
      if (this.duoMode) {
        this.updateSelectionPreview(input);
        this.updateStockOptions();
        this.updateDuoState();
        return;
      }

      if (input.name === 'option-colour') {
        if (this.colourLabel) {
          this.colourLabel.textContent = input.closest('label')?.querySelector('.visually-hidden')?.textContent || '';
        }
        this.updateSelectionPreview(input);
      }

      this.updateStockOptions();
      this.updateVariant();
    }

    updateSelectionPreview(input) {
      if (!input.name?.includes('colour')) return;
      const choice = input.closest('.pdp__selection-choice');
      const swatch = input.closest('label')?.querySelector('.pdp__swatch-dot');
      if (swatch) choice?.style.setProperty('--selected-swatch', swatch.style.getPropertyValue('--swatch'));
      const previews = choice?.querySelectorAll('[data-selection-preview-image]');
      if (!previews?.length) return;
      const colour = this.canonicalOptionValue(input);
      const matchingSlides = this.slides.filter((slide) => this.matchesColour(slide, colour));
      ['front', 'back'].forEach((face, index) => {
        const slide = matchingSlides.find((item) => item.dataset.mediaAlt.includes(face)) || matchingSlides[index];
        const image = slide?.querySelector('img');
        previews[index].src = image?.currentSrc || image?.src || input.dataset[`duo${face[0].toUpperCase()}${face.slice(1)}`];
        previews[index].alt = `${colour} Smossie Suit, ${face}`;
      });
    }

    updateDuoState() {
      const choices = [...this.querySelectorAll('[data-duo-choice]')];
      const groups = new Set(choices.map((input) => input.name));
      const selectedGroups = new Set(choices.filter((input) => input.checked).map((input) => input.name));
      const complete = groups.size > 0 && selectedGroups.size === groups.size;
      const selectedVariants = complete ? this.selectedDuoVariants() : [];
      const available =
        selectedVariants.length === 2 && selectedVariants.every((variant) => this.inStock(variant)) &&
        (selectedVariants[0].id !== selectedVariants[1].id ||
          selectedVariants[0].inventory_management == null || selectedVariants[0].inventory_quantity >= 2);

      this.setSubmitState({
        disabled: !complete || !available,
        label: complete ? this.submit?.dataset.soldOutLabel : this.submit?.dataset.incompleteLabel,
      });
    }

    selectedDuoVariants() {
      return [1, 2].map((suitNumber) => {
        const colour = this.canonicalOptionValue(this.querySelector(
          `input[name="properties[Suit ${suitNumber} colour]"]:checked`,
        ));
        const size = this.canonicalOptionValue(this.querySelector(
          `input[name="properties[Suit ${suitNumber} size]"]:checked`,
        ));
        if (!colour || !size) return null;
        return (
          this.duoComponentVariants.find(
            (variant) =>
              variant.options?.includes(colour) &&
              variant.options?.includes(size),
          ) || null
        );
      });
    }

    /**
     * Tapping a colour filters the gallery to it; tapping that same colour
     * again clears the filter and shows the whole set. The variant selection is
     * untouched either way — the filter is a view, not a choice.
     */
    onColourClick(input) {
      const colour = this.canonicalOptionValue(input);
      this.galleryColour = this.galleryColour === colour ? null : colour;
      this.renderGallery({ scroll: false });
    }

    optionsComplete() {
      const needsColour = Boolean(this.querySelector('input[name="option-colour"]'));
      const needsSize = Boolean(this.querySelector('input[name="option-size"]'));
      if (needsColour && !this.querySelector('input[name="option-colour"]:checked')) return false;
      if (needsSize && !this.querySelector('input[name="option-size"]:checked')) return false;
      return needsColour || needsSize;
    }

    /** Matches on every selected option value being present on the variant. */
    findVariant() {
      if (!this.optionsComplete()) return null;

      const wanted = this.selectedOptions;
      if (!wanted.length) return null;
      return (
        this.variants.find((variant) => wanted.every((value) => variant.options.includes(value))) || null
      );
    }

    updateVariant() {
      const variant = this.findVariant();

      if (!variant) {
        this.variantInput.value = '';
        const incomplete = !this.optionsComplete();
        this.setSubmitState({
          disabled: true,
          label: incomplete ? this.submit?.dataset.incompleteLabel : this.submit?.dataset.unavailableLabel,
        });
        return;
      }

      this.variantInput.value = variant.id;
      if (this.priceEl && typeof variant.price === 'number') {
        this.priceEl.textContent = window.Smossie.money(variant.price);
      }

      this.setSubmitState({ disabled: !this.inStock(variant), label: null });

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    setSubmitState({ disabled, label }) {
      if (!this.submit) return;
      this.submit.disabled = disabled;
      const labelEl = this.submit.querySelector('[data-add-to-cart-label]');
      if (!labelEl) return;
      if (!labelEl.dataset.defaultLabel) labelEl.dataset.defaultLabel = labelEl.textContent.trim();
      labelEl.textContent = disabled
        ? label || this.submit.dataset.soldOutLabel || labelEl.dataset.defaultLabel
        : this.submit.dataset.completeLabel || labelEl.dataset.defaultLabel;
    }

    /**
     * Alt text is how a merchant links a photo to a colourway without needing
     * one variant image per shot. Spacing is ignored on both sides so "Sky
     * Blue" still finds a photo tagged "skyblue".
     */
    matchesColour(slide, colour) {
      const flatten = (value) => (value || '').toLowerCase().replace(/[\s_-]+/g, '');
      return flatten(slide.dataset.mediaAlt).includes(flatten(colour));
    }

    /** The figures currently on show, in document order. */
    get visible() {
      if (!this.galleryColour) return this.slides;
      const matches = this.slides.filter((slide) => this.matchesColour(slide, this.galleryColour));
      // No tagged photo for this colour is a merchandising gap, not a reason to
      // show an empty frame.
      return matches.length ? matches : this.slides;
    }

    /** Decides what is visible while always respecting the selected layout. */
    renderGallery({ scroll }) {
      if (!this.gallery || !this.slides.length) return;

      const visible = this.visible;
      const mobileLayout = this.gallery.dataset.mobileLayout;
      const layout = this.mobileLayout.matches && mobileLayout !== 'desktop'
        ? mobileLayout : this.desktopLayout;
      const single = layout === 'gallery';

      this.gallery.dataset.layout = layout;
      this.gallery.dataset.mode = this.galleryColour ? 'filtered' : 'all';
      this.gallery.toggleAttribute('data-single', single);

      this.slides.forEach((slide, index) => {
        const shown = visible.includes(slide);
        slide.hidden = !shown;
        slide.toggleAttribute('data-primary', slide === visible[0]);
        if (this.thumbs[index]) this.thumbs[index].hidden = !shown;
      });

      this.activate(this.slides.indexOf(visible[0]), { scroll: false });

      if (!scroll) return;
      const behavior = this.motion;
      if (single) {
        this.gallery.scrollIntoView({ behavior, block: 'start' });
      } else if (window.matchMedia('(width < 60rem)').matches) {
        visible[0].parentElement.scrollTo({ left: 0, behavior });
      } else {
        visible[0].scrollIntoView({ behavior, block: 'start' });
      }
    }

    get motion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    /** Moves by `delta` through the visible set, wrapping at both ends. */
    step(delta) {
      const visible = this.visible;
      if (visible.length < 2) return;
      const current = visible.indexOf(this.slides[this.active]);
      const next = (current + delta + visible.length) % visible.length;
      this.activate(this.slides.indexOf(visible[next]));
    }

    activate(index, { scroll = true } = {}) {
      if (index < 0) return;
      const changed = this.active !== index;
      this.active = index;

      this.slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      this.thumbs.forEach((thumb, i) => {
        // `aria-current="false"` still reads as a landmark in some browsers, so
        // the attribute is removed rather than set to false.
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });

      if (changed) this.paintRing();
      if (scroll) this.centreThumb(index);
    }

    /**
     * The ring borrows one of the six colourways each time a new card is
     * highlighted. Same colour never lands twice in a row.
     */
    paintRing() {
      const last = this.ringColour;
      const pool = last ? this.ringColours.filter((colour) => colour !== last) : this.ringColours;
      this.ringColour = pool[Math.floor(Math.random() * pool.length)];
      this.gallery?.style.setProperty('--thumb-ring', this.ringColour);
    }

    /**
     * Keeps the ringed thumbnail in the middle of the rail. Scrolling the rail
     * directly rather than calling scrollIntoView, which would also drag the
     * page around it.
     */
    centreThumb(index) {
      const thumb = this.thumbs[index];
      if (!thumb || !this.thumbRail) return;
      const target = thumb.offsetLeft - (this.thumbRail.clientWidth - thumb.offsetWidth) / 2;
      this.thumbRail.scrollTo({ left: Math.max(0, target), behavior: this.motion });
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.variantInput.value || this.submit.disabled) return;

      this.errorEl.hidden = true;
      this.submit.disabled = true;

      try {
        let items;
        if (this.duoMode) {
          const variants = this.selectedDuoVariants();
          if (variants.length !== 2 || variants.some((variant) => !this.inStock(variant)) ||
              (variants[0].id === variants[1].id && variants[0].inventory_management != null &&
                variants[0].inventory_quantity < 2)) {
            throw new Error(this.submit.dataset.unavailableLabel);
          }
          const duoId = `duo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          items = variants.map((variant, index) => ({
            id: Number(variant.id),
            quantity: 1,
            properties: {
              _duo_id: duoId,
              _duo_position: String(index + 1),
            },
          }));
        } else {
          items = [{ id: Number(this.variantInput.value), quantity: 1 }];
        }

        const response = await fetch(`${window.Smossie.routes.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message);

        if (this.duoMode) {
          const discountApplied = await this.applyDuoDiscount();
          if (!discountApplied) {
            await this.rollbackAddedItems(payload.items || []);
            throw new Error(this.dataset.duoDiscountError);
          }
        }

        document.dispatchEvent(new CustomEvent('smossie:cart:changed', { detail: { open: true } }));
      } catch (error) {
        this.errorEl.textContent = error.message;
        this.errorEl.hidden = false;
      } finally {
        if (this.duoMode) this.updateDuoState();
        else this.updateVariant();
      }
    }

    async applyDuoDiscount() {
      const routes = window.Smossie.routes || {};
      const currentCart = await fetch(`${routes.cart || '/cart'}.js`).then((response) => response.json());
      const existingCodes = (currentCart.discount_codes || []).map((discount) => discount.code);
      const codes = [...new Set([...existingCodes, this.dataset.duoDiscountCode].filter(Boolean))];
      const response = await fetch(`${routes.cartUpdate || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') }),
      });
      if (!response.ok) return false;
      const cart = await response.json();
      return cart.items.some((item) =>
        (item.line_level_discount_allocations || []).some(
          (allocation) =>
            allocation.discount_application?.title?.replace(/\s+/g, '').toUpperCase() ===
            this.dataset.duoDiscountCode.toUpperCase(),
        ),
      );
    }

    async rollbackAddedItems(items) {
      const updates = Object.fromEntries(items.map((item) => [item.key, 0]).filter(([key]) => key));
      if (!Object.keys(updates).length) return;
      const routes = window.Smossie.routes || {};
      await fetch(`${routes.cartUpdate || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }
  }

  if (!customElements.get('smossie-product')) {
    customElements.define('smossie-product', SmossieProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
